<template>
  <el-row class="mt-65 ml-16 mr-16">
    <el-col
      :sm="{span:14, offset: 5}"
      :md="{span:12, offset: 6}"
      :lg="{span:12, offset: 6}"
      v-loading.fullscreen.lock="fullscreenLoading"
    >
      <el-form
        :model="loginForm"
        :rules="getFormRules"
        ref="loginForm"
        label-position="top"
        class="auth"
        @keyup.native.enter="submitForm('loginForm')"
      >
        <h2 class="auth-title">
          {{ $t('auth.sign-in') }}
        </h2>
        <img
          class="auth-logo"
          src="../../assets/img/logo.png"
          alt="Tippie"
          width="150px"
        >
        <el-form-item
          :label="$t('profile.phone')"
          prop="phone"
        >
          <vue-tel-input 
            v-model="loginForm.phone"  
            @input="trimSpaces($event, 'phone')"
          />
        </el-form-item>
        <el-form-item
          :label="$t('profile.password')"
          prop="password"
        >
          <el-input
            v-model="loginForm.password"
            @input="trimSpaces($event, 'password')"
            show-password
          />
        </el-form-item>
        <el-form-item>
          <router-link
            class="small-link"
            :to="{ name: 'ResetPassword'}"
          >
            {{ $t('auth.forgot-pass') }}
          </router-link>
        </el-form-item>
        <el-form-item class="align-center mt-25 mb-20">
          <el-button
            type="primary"
            @click="submitForm('loginForm')"
            class="primary-button"
          >
            {{ $t('auth.sign-in') }}
          </el-button>
          <p>
            {{ $t('auth.user-terms-text') }}
            <a
              href="https://tippie.de/agb/"
              target="_blank"
            >
              {{ $t("auth.user-terms-link") }}
            </a>
          </p>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>
import { Auth } from '@aws-amplify/auth'
import authHelpers from '../../plugins/auth-helpers';

export default {
  name: 'SignIn',
  data: () => ({
    fullscreenLoading: false,
    loginForm: {
      phone: '',
      password: ''
    }
  }),
  created () {
    window.location.href = process.env.VUE_APP_NEW_DESIGN_ADMIN_URL;
    return

    // Auth.currentAuthenticatedUser().then(() => {
    //   this.$router.push({ name: 'User' });
    // });
  },
  computed: {
    getFormRules: function () {
      return {
        phone: [
          {
            required: true,
            message: this.$t('form.validation.required', { field: this.$t('profile.phone') }),
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: this.$t('form.validation.required', { field: this.$t('profile.password') }),
            trigger: 'blur'
          }
        ]
      };
    }
  },
  methods: {
    trimSpaces (value = "", field) {
      this.loginForm[field] = value.replace(/\s/g, "");
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.signIn();
        } else {
          return false;
        }
      });
    },
    signIn () {
      this.fullscreenLoading = true;
      const phone = this.loginForm.phone.replace(/[^\d.+]/g, '');
      Auth.signIn(phone, this.loginForm.password).then((user) => {
        if (window.messageHandler) {
          user.getSession((err, session) => {
            const message = {"type": "login_completed", "token": session.getAccessToken().getJwtToken()};
            window.messageHandler.postMessage(JSON.stringify(message));
          });
        }
        
        this.$axios.post('/api/v1/fe-status', {
          empUid: user.attributes.sub,
          status: 200,
          message: 'Payment page event User logged in',
          timestamp: Date.now()
        });


  if (this.$router.currentRoute.name !== "Pay") {
      Auth.currentAuthenticatedUser({
        bypassCache: true,
      }).then(async (user) => {
        if(await authHelpers.isCurrentUserAdmin()) return
        this.$adminApi
          .get("/api/v1/entities/employees/" + user.attributes.sub)
          .then(async (response) => {
            response.data.forEach(org => {
              if (
              org.newDesignAdmin &&
              process.env.VUE_APP_NEW_DESIGN_ADMIN_URL
            ) {
              window.location.href = process.env.VUE_APP_NEW_DESIGN_ADMIN_URL;
              return;
            }
            });
          });
      });
    }

        this.$router.push({ name: 'User' });
      }).catch((error) => {
        this.fullscreenLoading = false;
        this.$message.error(error.message);
      });
    }
  }
};
</script>

<style scoped lang="scss">

</style>
